/* eslint-disable import/no-cycle */
import api from './api.service';

function index(teacherId, params) {
  return api.get(`/teachers/${teacherId}/schools`, params);
}

function get(teacherId, id, params) {
  return api.get(`/teachers/${teacherId}/schools/${id}`, params);
}

function create(teacherId, params) {
  return api.post(`/teachers/${teacherId}/schools`, params);
}

function update(teacherId, id, params) {
  return api.put(`/teachers/${teacherId}/schools/${id}/update`, params);
}

function remove(teacherId, id, params) {
  return api.delete(`/teachers/${teacherId}/schools/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.teacher_id, params.id, params) : create(params.teacher_id, params);
}


export const teachersSchoolsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
};
